import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Order } from 'src/app/models/order.model';

@Component({
  selector: 'app-ticket-success',
  templateUrl: './ticket-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketSuccessComponent {
  readonly order = input<Order | null>(null);

  readonly closed = output<boolean>();

  onClosed(): void {
    this.closed.emit(true);
  }
}
